var _g, _g2, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyAquaculture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 300,
    viewBox: "0 0 400 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "tank"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 100 H350 V250 Q200 300 50 250 Z",
    fill: "#E3F2FD",
    stroke: "#2196F3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "water-wave",
    d: "M50 180 Q125 150 200 180 Q275 210 350 180",
    stroke: "#2196F3",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "3s",
    repeatCount: "indefinite",
    values: "             M50 180 Q125 150 200 180 Q275 210 350 180;             M50 180 Q125 210 200 180 Q275 150 350 180;             M50 180 Q125 150 200 180 Q275 210 350 180"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "fish",
    transform: "translate(200, 200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 Q20 -15 40 0 Q20 15 0 0Z",
    fill: "#FF9800"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "-50,0; 50,0; -50,0",
    dur: "4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: -5,
    r: 2,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 0 L45 -8 L45 8 Z",
    fill: "#FF9800"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 80,
    textAnchor: "middle",
    fill: "#2E7D32",
    fontSize: 16,
    fontWeight: "bold"
  }, "\n      No Complaints Yet\n    ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 100,
    textAnchor: "middle",
    fill: "#666",
    fontSize: 14
  }, "\n      Your aquaculture history will appear here\n    ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAquaculture);
export default __webpack_public_path__ + "static/media/EmptyAquaculture.2accf0c83dfc2e547c3a3b34005b726d.svg";
export { ForwardRef as ReactComponent };